import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import MetaTags from "react-meta-tags";
import axios from "axios";
import { Card, CardBody, Container, Row, Col } from "reactstrap";
import bgImage from "../../assets/images/Certificate-backgroud.jpg";
import Signature from "../../assets/images/Signature-Image.png";
/* Accreditation Logos */
import ais from "../../assets/images/AIS-logo.png";
import uk from "../../assets/images/Global-bureau.jpg";
import bqsr from "../../assets/images/Combined-logos.png";
import ias from "../../assets/images/IAS-logo.png";
import iaf from "../../assets/images/IAF-logo.jpg";
import { QRCodeCanvas } from "qrcode.react";
import nhsLogo from "../../assets/images/NHS logo.png";
import NeqasLogo from "../../assets/images/LogoNeqas.jpg";
import ribbonImage from "../../assets/images/Ribbon-Image.jpg";
import "../../assets/css/participant-certificate.scss"; // ✅ plain global import — no "styles" object

class Certificate extends Component {
  constructor(props) {
    super(props);
    this.certificateRef = null;
    this.state = {
      participant_name: "",
      city: "",
      scheme_name: "",
      cycle_no: "",
      remaining_rounds: "",
      year: "",
      logo: "",
      sign: "",
      account_id: "",
scheme_id: "",
cycle_id: "",
      processedLogos: [],
      processedSignature: "",
      processedRibbon: "",
    };
  }

  componentDidMount() {
    const participant_id = this.props.match?.params?.id;
    const queryParams = new URLSearchParams(this.props.location.search);
    let scheme_id = queryParams.get("scheme_id");
    let cycle_id = queryParams.get("cycle_id");

    this.makeTransparent(ribbonImage, (transparentRibbon) => {
      this.setState({ processedRibbon: transparentRibbon });
    });
    this.processAllLogos([ais, uk, bqsr]);
    this.makeTransparent(Signature, (transparentSignature) => {
      this.setState({ processedSignature: transparentSignature });
    });

    if (!participant_id) return;

    const fetchCertificate = (sid, cid) => {
      axios
        .get(
          `https://externalqcapi.com/api/lab/certificate/generate/${participant_id}/`,
          {
            params: { participant_id, scheme_id: sid, cycle_id: cid },
          },
        )
        .then((res) => {
          const data = res.data;
          this.setState({
            participant_name: data.participant_name || "",
            city: data.city || "",
            scheme_name: data.scheme_name || "",
            cycle_no: data.cycle_no || "",
            remaining_rounds: data.remaining_rounds || "",
            cycle_start_date: data.cycle_start_date || "",
            cycle_end_date: data.cycle_end_date || "",
            account_id: data.account_id || "",  // ← ADD
  scheme_id: sid,                      // ← ADD
  cycle_id: cid,  
          });
        })
        .catch((err) => console.error("Certificate API error:", err));
    };

    if (scheme_id && cycle_id) {
      fetchCertificate(scheme_id, cycle_id);
    } else {
      axios
        .get(
          `https://externalqcapi.com/api/lab/participant-active-cycle/${participant_id}/`,
        )
        .then((res) => {
          const { scheme_id: sid, cycle_id: cid } = res.data;
          fetchCertificate(sid, cid);
        })
        .catch((err) => console.error("Failed to fetch active cycle:", err));
    }
  }

  makeTransparent = (imgSrc, callback) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imgSrc;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      for (let i = 0; i < data.length; i += 4) {
        if (data[i] > 240 && data[i + 1] > 240 && data[i + 2] > 240) {
          data[i + 3] = 0;
        }
      }
      ctx.putImageData(imageData, 0, 0);
      callback(canvas.toDataURL());
    };
  };

  processAllLogos = (logos) => {
    const processed = new Array(logos.length).fill(null); // preserve order
    let completed = 0;

    logos.forEach((logo, index) => {
      this.makeTransparent(logo, (transparentSrc) => {
        processed[index] = transparentSrc; // insert at correct index
        completed++;
        if (completed === logos.length) {
          this.setState({ processedLogos: processed });
        }
      });
    });
  };

  formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-4);
    return `${day} ${month} ${year}`;
  };

  formatYear = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.getFullYear();
  };

  downloadPDF = async () => {
    const { jsPDF } = await import("jspdf");
    const W = 1123;
    const H = 794;
    const SCALE = 3;
    const canvas = document.createElement("canvas");
    canvas.width = W * SCALE;
    canvas.height = H * SCALE;
    const ctx = canvas.getContext("2d");
    ctx.scale(SCALE, SCALE);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    const loadImage = (src) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`Failed to load: ${src}`));
        img.src = src;
      });

    try {
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);
      const bg = await loadImage(bgImage);
      ctx.drawImage(bg, 0, 0, W, H);
      ctx.strokeStyle = "#f60f0f";
      ctx.lineWidth = 1.5;
      ctx.strokeRect(1, 1, W - 2, H - 2);
      const RIBBON_W = 330;
      ctx.save();
      ctx.beginPath();
      ctx.rect(0, 0, RIBBON_W, H);
      ctx.clip();
      const ribbonSrc = this.state.processedRibbon || ribbonImage;
      const ribbon = await loadImage(ribbonSrc);
      const rAspect = ribbon.width / ribbon.height;
      const rH = H;
      const rW = rH * rAspect;
      const finalRW = Math.max(RIBBON_W, rW);
      const finalRH = finalRW / rAspect;
      const rOffsetY = (H - finalRH) / 2;
      ctx.drawImage(ribbon, 0, rOffsetY, finalRW, finalRH);
      ctx.restore();
      const CONTENT_X = RIBBON_W + 20;
      const CONTENT_W = W - RIBBON_W - 40;
      const CENTER_X = RIBBON_W + CONTENT_W / 2;
      const neqas = await loadImage(NeqasLogo);
      const logoH = 75;
      const logoW = (neqas.width / neqas.height) * logoH;
      ctx.drawImage(neqas, CENTER_X - logoW / 2, 50, logoW, logoH);
      const allCanvases = document.querySelectorAll("canvas");
      if (allCanvases.length > 0) {
        const qrCanvas = allCanvases[allCanvases.length - 1];
        ctx.drawImage(qrCanvas, W - 115, 45, 95, 95);
      }
      ctx.textAlign = "center";
      ctx.fillStyle = "#000000";
      ctx.font = "bold 30px Arial";
      ctx.letterSpacing = "3px";
      ctx.fillText("CERTIFICATE OF PARTICIPATION", CENTER_X, 165);
      ctx.letterSpacing = "0px";
      ctx.font = "15px Georgia";
      ctx.fillStyle = "#0a0000";
      ctx.fillText(
        "NHS - National External Quality Assessment Scheme / Proficiency Testing",
        CENTER_X,
        198,
      );
      const {
        participant_name,
        city,
        scheme_name,
        cycle_no,
        cycle_start_date,
        remaining_rounds,
        processedSignature,
      } = this.state;
      ctx.font = "bold 26px Arial";
      ctx.fillStyle = "#000000";
      const nameText = `${participant_name || "-"}${city ? " - " + city : ""}`;
      ctx.fillText(nameText, CENTER_X, 295);
      ctx.strokeStyle = "#000000";
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.moveTo(CENTER_X - 220, 318);
      ctx.lineTo(CENTER_X + 220, 318);
      ctx.stroke();
      ctx.font = "17px Georgia";
      ctx.fillStyle = "#0a0000";
      ctx.fillText(
        "Has enrolled in the Quality Assessment Program",
        CENTER_X,
        360,
      );
      ctx.font = "bold 21px Arial";
      ctx.fillStyle = "#000000";
      ctx.fillText(scheme_name || "-", CENTER_X, 400);
      ctx.font = "17px Georgia";
      ctx.fillStyle = "#0a0000";
      const year = this.formatYear(cycle_start_date);
      ctx.fillText(
        `Cycle ${cycle_no || "-"} = ${year}  |  Enrolled Rounds: ${
          remaining_rounds ?? "-"
        }`,
        CENTER_X,
        438,
      );
      const logoSrcs = [ais, uk, bqsr];
      const LOGO_H = 55;
      const loadedLogos = [];
      for (const src of logoSrcs) {
        try {
          const img = await loadImage(src);
          const lw = (img.width / img.height) * LOGO_H;
          loadedLogos.push({ img, lw });
        } catch (e) {
          console.warn("Logo skip:", e.message);
        }
      }
      let logoX = CONTENT_X + 10;
      const logoY = H - 115;
      for (const { img, lw } of loadedLogos) {
        ctx.drawImage(img, logoX, logoY, lw, LOGO_H);
        logoX += lw + 12;
      }
      try {
        const sigSrc = processedSignature || Signature;
        const sig = await loadImage(sigSrc);
        const sigW = 130;
        const sigH = 45;
        const sigX = W - 260;
        const sigY = H - 125;
        ctx.drawImage(sig, sigX, sigY, sigW, sigH);
        ctx.strokeStyle = "#000000";
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.moveTo(sigX - 25, sigY + sigH + 4);
        ctx.lineTo(sigX + sigW + 25, sigY + sigH + 4);
        ctx.stroke();
        ctx.font = "11px Arial";
        ctx.fillStyle = "#000000";
        ctx.textAlign = "center";
        const labelX = sigX + sigW / 2;
        ctx.fillText(
          "Director Scientific Affairs, NCQA",
          labelX,
          sigY + sigH + 18,
        );
        ctx.fillText("NHS \u2013 NEQAS", labelX, sigY + sigH + 32);
        ctx.fillText("ASAB, NUST", labelX, sigY + sigH + 46);
      } catch (e) {
        console.warn("Signature failed:", e.message);
      }
      const imgData = canvas.toDataURL("image/jpg", 1.0);
      const pdf = new jsPDF("landscape", "mm", "a4");
      pdf.addImage(imgData, "JPG", 0, 0, 297, 210);
      pdf.save("certificate.pdf");
    } catch (err) {
      console.error("PDF generation failed:", err);
      alert("PDF generation failed: " + err.message);
    }
  };

  render() {
    const {
      participant_name,
      city,
      scheme_name,
      cycle_no,
      cycle_start_date,
      remaining_rounds,
      processedLogos,
    } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Certificate</title>
          </MetaTags>

          <Container fluid>
            {/* Download Button */}
            <div className="downloadButtonWrapper">
              <button className="btn btn-secondary" onClick={this.downloadPDF}>
                Download PDF
              </button>
            </div>

            <Row className="justify-content-center">
              <Col style={{ display: "flex", justifyContent: "center" }}>
                <Col style={{ display: "flex", justifyContent: "center" }}>
                  <div ref={(el) => (this.certificateRef = el)}>
                    <Card
                      data-certificate="true"
                      className="certificateCard"
                      style={{ backgroundImage: `url(${bgImage})` }}
                    >
                      <CardBody className="certificateCardBody">
                        <Row className="g-0 certificateRow">
                          {/* LEFT — Ribbon */}
                          <Col md="2" className="ribbonCol">
                            {this.state.processedRibbon && (
                              <img
                                src={this.state.processedRibbon}
                                alt="Ribbon"
                                className="ribbonImage"
                              />
                            )}
                          </Col>

                          {/* RIGHT — Content */}
                          <Col
                            md="10"
                            className="text-center d-flex flex-column contentCol"
                          >
                            {/* Logo + QR */}
                            <div className="logoQrWrapper">
                              <img
                                src={NeqasLogo}
                                alt="NHS"
                                className="neqasLogo"
                              />
                              <div className="qrCodeWrapper">
                              <QRCodeCanvas
  value={`${window.location.origin}/${this.props.match.params.organization_name}/${this.props.match.params.id}/COP-verification?account_id=${this.state.account_id}&scheme_id=${this.state.scheme_id}&cycle_id=${this.state.cycle_id}`}
  size={90}
/>
                              </div>
                            </div>

                            {/* Title */}
                            <div className="certTitle">
                              CERTIFICATE OF PARTICIPATION
                            </div>

                            {/* Subtitle */}
                            <Row className="justify-content-center">
                              <Col md="8">
                                <p className="certSubtitle">
                                  NHS - National External Quality Assessment
                                  Scheme / Proficiency Testing
                                </p>
                              </Col>
                            </Row>

                            {/* Participant Name */}
                            <h2 className="fw-bold mt-4">
                              {participant_name || "-"} -{" "}
                              {this.state.city ? `${this.state.city} ` : ""}
                            </h2>

                            {/* Divider */}
                            <div className="divider"></div>

                            {/* Enrolled Text */}
                            <p className="enrolledText">
                              Has enrolled in the Quality Assessment Program
                            </p>

                            {/* Scheme Name */}
                            <h4 className="fw-bold">{scheme_name || "-"}</h4>

                            {/* Cycle Info */}
                            <p className="cycleText">
                              Cycle {cycle_no || "-"} ={" "}
                              {this.formatYear(cycle_start_date)}
                              {" | "}
                              Enrolled Rounds: {remaining_rounds ?? "-"}
                            </p>

                            {/* Bottom: Logos + Signature */}
                            <Row className="g-0 mt-auto bottomRow">
                              <Col
                                md="12"
                                className="d-flex align-items-center"
                                style={{
                                  padding: "0 10px",
                                  justifyContent: "space-between",
                                }}
                              >
                                {/* Accreditation Logos — hard left */}
                                <div className="logosWrapper">
                                  <div>
                                    <img
                                      src={processedLogos[0]}
                                      alt="logo-1"
                                      className="accreditationLogo"
                                    />
                                  </div>
                                  <div>
                                    <img
                                      src={processedLogos[1]}
                                      alt="logo-2"
                                      className="accreditationLogo"
                                    />
                                  </div>
                                  <div>
                                    <img
                                      src={processedLogos[2]}
                                      alt="logo-3"
                                      className="accreditationLogo"
                                    />
                                  </div>
                                </div>

                                {/* Signature — hard right */}
                                <div className="signatureSection">
                                  <div className="signatureInner">
                                    <img
                                      src={
                                        this.state.processedSignature ||
                                        Signature
                                      }
                                      alt="signature"
                                      className="signatureImage"
                                    />
                                    <div className="signatureLine" />
                                  </div>
                                  <div className="signatureLabels">
                                    <div>Director Scientific Affairs, NCQA</div>
                                    <div>NHS – NEQAS</div>
                                    <div>ASAB, NUST</div>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </div>
                </Col>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Certificate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      organization_name: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(Certificate);
